import React from 'react'
import { createPortal } from 'react-dom'
import { Button } from 'antd'
import { FormattedMessage } from 'react-intl'
import { WhatsAppOutlined } from '@ant-design/icons'
import cn from 'classnames'

import WelcomeIllustration from './WelcomeIllustration'
import styles from './financeOnboarding.module.scss'

const ICON_BASE = 'resources/images/icons/menu-v2'

export const STEP_CARDS = [
  { n: 1, icon: `${ICON_BASE}/receipt.svg`, eta: '± 2 menit' },
  { n: 2, icon: null, eta: '± 30 detik' },
  { n: 3, icon: `${ICON_BASE}/reports.svg`, eta: '± 30 detik' },
]

// Layar selamat datang, menggantikan wizard setup lama untuk perusahaan baru.
const Welcome = ({ name, onStart }) =>
  createPortal(
    <div className={styles.welcome} role="dialog" aria-modal="true">
      <div className={styles.welcomeLeft}>
        <WelcomeIllustration />
      </div>
      <div className={styles.welcomeRight}>
        <span className={styles.eyebrow}>
          <i />
          <FormattedMessage id="financeOnboarding.welcome_eyebrow" />
        </span>
        <h1 className={styles.welcomeTitle}>
          <FormattedMessage
            id="financeOnboarding.welcome_title"
            values={{ name: <span>{name}</span> }}
          />
        </h1>
        <p className={styles.lead}>
          <FormattedMessage id="financeOnboarding.welcome_lead" />
        </p>
        <div className={styles.steps}>
          {STEP_CARDS.map((card) => (
            <div key={card.n} className={cn(styles.stepCard, card.n === 1 && styles.stepActive)}>
              <div className={cn(styles.ico, !card.icon && styles.icoWa)}>
                {card.icon ? <img src={card.icon} alt="" /> : <WhatsAppOutlined />}
              </div>
              <div>
                <h4>
                  <FormattedMessage id={`financeOnboarding.step${card.n}_title`} />
                </h4>
                <p>
                  <FormattedMessage id={`financeOnboarding.step${card.n}_desc`} />
                </p>
              </div>
              <span className={styles.eta}>{card.eta}</span>
            </div>
          ))}
        </div>
        <div className={styles.welcomeActions}>
          <Button
            type="primary"
            size="large"
            block
            onClick={onStart}
            id="btn-finance-onboarding-start"
          >
            <FormattedMessage id="financeOnboarding.start" /> →
          </Button>
          <span className={styles.note}>
            <FormattedMessage id="financeOnboarding.welcome_note" />
          </span>
        </div>
      </div>
    </div>,
    document.body,
  )

export default Welcome
